import { getTitleFontSize } from 'helpers/collection';
import styles from './object-title.module.scss';
import LegacyOrMarkdownParser from 'components/rich-text/legacy-or-markdown-parser';

const ObjectTitle = ({ title }: { title: string }) => {
	const titleSize = getTitleFontSize(title);
	return (
		<h1 className={`${styles.title} ${styles[titleSize]}`}>
			<LegacyOrMarkdownParser>{title}</LegacyOrMarkdownParser>
		</h1>
	);
};

export default ObjectTitle;
